import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import {
    createUserWithEmailAndPassword,
    getAuth,
    signInWithEmailAndPassword,
    signOut as firebaseSignOut,
    GoogleAuthProvider,
    signInWithRedirect,
    sendPasswordResetEmail,
} from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyAmELA5lDEjt6MIpF6pw1SfUiBtw1iEEos",
    authDomain: "moku-erp.firebaseapp.com",
    projectId: "moku-erp",
    storageBucket: "moku-erp.appspot.com",
    messagingSenderId: "964388158321",
    appId: "1:964388158321:web:ddd837d007a7812b2414d0",
    measurementId: "G-P7JECXWTCH",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export const signIn = async (email, password) => {
    try {
        const res = await signInWithEmailAndPassword(auth, email, password);
        return res.user;
    } catch (e) {
        return e.code;
    }
};

export const signUp = async (email, password) => {
    try {
        const res = await createUserWithEmailAndPassword(auth, email, password);
        return res.user;
    } catch (e) {
        return e.code;
    }
};

export const signOut = async () => {
    try {
        await firebaseSignOut(auth);
    } catch (e) {
        console.error("Error signing out:", e);
    }
};

export const resetPassword = async (email) => {
    try {
        const res = sendPasswordResetEmail(auth, email);
        return res;
    } catch (e) {
        return e.code;
    }
};
